import {FC, useMemo} from 'react'
import { format, parseISO } from 'date-fns'
type Props = {
    date_val?: string
    date_format?: string
    stack?: boolean
}

const ShowDateCell: FC<Props> = ({date_val, date_format, stack = false}) => {
    
    const {show_date, show_time, max_w} = useMemo(() => {
        
        let _show_dt = null;
        let _show_tm = null;
        let _max_w = '';
        
        if (date_val) {
            try { 
                const _dtval = parseISO(date_val);                
                if (_dtval) {
                    let _dt_format = 'MMM d, yyyy';
                    let _tm_format = 'h:mm a';

                    let _dtstr = format(_dtval, _dt_format);
                    let _tmstr = format(_dtval, _tm_format);

                    if (date_format === 'dateOnly') {
                        _show_dt = <div>{_dtstr}</div>;
                        _max_w = 'w-100px';
                    } else if (date_format) {
                        _dtstr = format(_dtval, date_format);
                        _show_dt = <div>{_dtstr}</div>;
                        _max_w = 'w-150px';
                    } else if (stack) {
                        _show_dt = <div>{_dtstr}</div>;
                        _show_tm = <div>{_tmstr}</div>;
                        _max_w = 'w-80px';
                    } else {
                        _show_dt = <div>{`${_dtstr} ${_tmstr}`}</div>
                        _max_w = 'w-150px';
                    }
                }                
            } catch (err) {
                // do nothing                   
            }            
        }
        
        return {show_date : _show_dt, show_time: _show_tm, max_w: _max_w};

    }, [date_val, date_format, stack]);
    
    if (! show_date) {
        return null;
    }
    return (
        <div className={'badge badge-light fs-8 d-flex flex-column align-items-center ' + max_w}>
            {show_date}
            {show_time}
        </div>    
    )    

}




export {ShowDateCell}
